import React, { useState } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';

import {
  Checkbox,
  Divider,
  FormControlLabel,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Tooltip,
} from '@mui/material';

import { WidthFull, WidthNormal } from '@mui/icons-material'

// === COMPONENTS ===
import { ImageCanvas } from './Canvas';
import { toBoolean } from 'components/utils';
import { Spacer } from 'components/Spacer';

// === CSS ===
import './image.css';

function Image( props ) {

  //#region [VALUES]

  const theme = useTheme()

  let is_magnifier_held_default = toBoolean( localStorage.getItem( 'image-magnifier-hold' ) );
  let magnifier_size_default    = +( localStorage.getItem( 'image-magnifier-size' ) ) || 100;
  let is_full_size_default      = toBoolean( localStorage.getItem( 'image-size' ) );

  const [ is_full_size      , setIsFullSize      ] = useState( is_full_size_default      );
  const [ is_magnifier_held , setIsMagnifierHeld ] = useState( is_magnifier_held_default );
  const [ magnifier_size    , setMagnifierSize   ] = useState( magnifier_size_default    );

  const settings = {
    is_full_size,
    is_magnifier_held,
    magnifier_size,
  }
    
  //#endregion

  //#region [STYLES]
  
  const _styles = {
    container: {
      gridColumn : 'span ' + props.fill || 6,
      position   : 'relative' ,
      overflow   : 'hidden'   ,
      width      : '100%'     ,
      height     : '100%'     ,
    },
    container_image: {
      position   : 'relative' ,
      overflow   : 'auto'     ,
      width      : '100%'     ,
      height     : 'calc( 100% - 5rem )',
    },
    control_box: {
      position   : 'relative' ,
      margin     : '0.5rem'   ,
      display    : 'flex'     ,
      height     : '4rem'     ,
      opacity    : '1'        ,
      transition : 'opacity 0.8s ease',
      zIndex     : 30,
    },
    image_paper: {
      gridColumn : 'span 6'   ,
      overflow   : 'auto'     ,
      width      : '100%'     ,
      position   : 'relative' ,
      height     : '100%'     ,
    }
  }

  const CONTAINER = {
    style: _styles.container,
  }

  const CONTAINER_IMAGE = {
    style: _styles.container_image,
  }

  const CONTROL_BOX = {
    style: _styles.control_box,
  }
    
  //#endregion

  //#region [EFFECT]

  //#endregion

  //#region [EVENTS]
  
  //-----------------------------------------------------------------
  function toggleImageSize() {
    //-----------------------------------------------------------------
    setIsFullSize ((prev) => !prev)
    localStorage.setItem( 'image-size', !is_full_size );
  }
  
  //-----------------------------------------------------------------
  function onChange_MagnifierHeld( event ) {
    //-----------------------------------------------------------------
    setIsMagnifierHeld(event.target.checked)
    localStorage.setItem( 'image-magnifier-hold', event.target.checked );
  }
  
  //-----------------------------------------------------------------
  function onChange_MagnifierSize( event ) {
    //-----------------------------------------------------------------
    const number = Number(event.target.value);
    if (0 <= number && number <= 999) {
      setMagnifierSize( number );
      localStorage.setItem( 'image-magnifier-size', number );
    }
  }

  //#endregion 

  //#region [RENDER]
  
  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <div { ...CONTAINER } >
        <div { ...CONTROL_BOX } >
          <Spacer fill />
          <Tooltip title={is_full_size ? 'Fit Page' : 'Fit Width'}>
            <IconButton size='large' onClick={toggleImageSize} color='primary'>
              {is_full_size ? <WidthNormal fontSize="large" /> : <WidthFull fontSize="large" />}
            </IconButton>
          </Tooltip>
          <Spacer width='2rem' />
          <Divider orientation="vertical" flexItem sx={{ borderRightWidth: 2, borderColor: theme.palette.primary[theme.palette.mode] }} />
          <Spacer width='4rem' />
          <div style={{ width: '100%', display: 'flex', justifyContent:'center', alignItems: 'center'}}>
            Magnifier:
            <Spacer />
            <FormControl sx={{ m: 1, width: '7rem' }} variant="outlined">
              <InputLabel htmlFor="magnifier-size-input">Size</InputLabel>
              <OutlinedInput
                id="magnifier-size-input"
                value={magnifier_size}
                size='small'
                label='Size'
                onChange={onChange_MagnifierSize}
                endAdornment={<InputAdornment position="end">%</InputAdornment>}
              />
            </FormControl>
            <Spacer />
            <FormControlLabel
              label   = "Keep maintained"
              control ={<Checkbox defaultChecked={is_magnifier_held_default} onChange={onChange_MagnifierHeld}/>}
            />
          </div>
          <Spacer fill />
        </div>
        <div { ...CONTAINER_IMAGE } >
          <ImageCanvas settings={settings} />
        </div>
      </div>
    )
  }

  //#endregion
  
  return display();
}

export {Image};